export default __webpack_public_path__ + "static/Baden-TV_SEO-Optimierung-3aa8a8492108c5a31b6a1d56ceb22d0d.mp4";